import { LoadingButton } from "@mui/lab";
import { useEffect, useRef } from "react";

export default function LoginQR({ showLoginQR, qrData, otp, setOtp, handleSubmintOTP, showOtp, loading }) {
    // avoid rendering hooks when component isn't active
    if (!showLoginQR && !showOtp) return null;
    const hasSubmittedRef = useRef(false);
    const handleChange = (value, index) => {
        if (!/^\d?$/.test(value)) return;

        const newOtp = [...otp];
        newOtp[index] = value;
        setOtp(newOtp);

        // Move to next input
        if (value && index < 5) {
            document.getElementById(`otp-${index + 1}`)?.focus();
        }
    };

    const handleKeyDown = (e, index) => {
        if (e.key === "Backspace") {
            const newOtp = [...otp];

            if (otp[index]) {
                newOtp[index] = "";
                setOtp(newOtp);
            } else if (index > 0) {
                newOtp[index - 1] = "";
                setOtp(newOtp);
                document.getElementById(`otp-${index - 1}`)?.focus();
            }
        }
    };

    useEffect(() => {
        if (
            !loading &&
            otp.length === 6 &&
            otp.every(digit => digit !== "") &&
            !hasSubmittedRef.current
        ) {
            hasSubmittedRef.current = true;
            handleSubmintOTP();
        }
    }, [otp, loading]);

    useEffect(() => {
        if (otp.some(digit => digit === "")) {
            hasSubmittedRef.current = false;
        }
    }, [otp]);

    //---------newcode---------
    useEffect(() => {
        if (showOtp) {
            setTimeout(() => {
                document.getElementById("otp-0")?.focus();
            }, 100);
        }
    }, [showOtp]);

    //-----------$-------------

    return (
        <div className="bg-page-bg min-h-screen flex flex-col font-display text-text-navy">
            <main className="flex-1 flex flex-col items-center justify-center p-6 lg:p-12">
                <div className="w-full max-w-5xl bg-white rounded-xl shadow-xl shadow-gray-200/50 overflow-hidden border border-border-light">
                    <div className={`grid grid-cols-1 ${showLoginQR ? "md:grid-cols-2" : ""} divide-y md:divide-y-0 md:divide-x divide-border-light`}>

                        {/* QR SECTION */}
                        {showLoginQR && !showOtp && (
                            <div className="p-6 flex flex-col items-center text-center">
                                <h3 className="text-xl font-bold mb-2">Authenticator App</h3>
                                <p className="text-slate-500 text-sm max-w-xs mb-6">
                                    Scan this QR code with Google Authenticator or Authy.
                                </p>

                                <img
                                    src={qrData}
                                    alt="Login QR Code"
                                    className="w-64 h-64 object-contain"
                                />
                            </div>
                        )}

                        {/* OTP SECTION */}
                        {(showOtp || showLoginQR) && (
                            <div className="p-6 flex flex-col">
                                <h3 className="text-xl font-bold mb-2">One-Time Password</h3>
                                <p className="text-slate-500 text-sm mb-8">
                                    Enter the 6-digit verification code.
                                </p>
                                <fieldset className="flex justify-center gap-2 mb-8">
                                    {otp?.map((digit, index) => (
                                        // <input
                                        //     disabled={loading}
                                        //     key={index}
                                        //     id={`otp-${index}`}
                                        //     type="text"
                                        //     inputMode="numeric"
                                        //     maxLength={1}
                                        //     value={digit}
                                        //     onChange={(e) => handleChange(e.target.value, index)}
                                        //     onKeyDown={(e) => handleKeyDown(e, index)}
                                        //     className="h-14 w-10 md:h-12 md:w-10 text-center text-2xl font-bold rounded-lg bg-gray-50 border-2 border-border-light focus:border-primary outline-none transition-all"
                                        // />

                                        //-----new code---------------

                                        <input
                                            disabled={loading}
                                            key={index}
                                            id={`otp-${index}`}
                                            type="text"
                                            inputMode="numeric"
                                            maxLength={1}
                                            value={digit}
                                            onChange={(e) => handleChange(e.target.value, index)}
                                            onKeyDown={(e) => handleKeyDown(e, index)}
                                            className="h-14 w-10 md:h-12 md:w-10 
                                               text-center text-2xl font-bold 
                                               rounded-lg bg-gray-50 
                                               border-2 border-gray-300 
                                               focus:border-black 
                                               focus:ring-2 focus:ring-black/20 
                                               outline-none 
                                               transition-all 
                                               caret-black"
                                        />

                                        //--------$-------------------
                                    ))}
                                </fieldset>
                                <div className="flex justify-center">
                                    <LoadingButton
                                        loading={loading}
                                        disabled={loading}
                                        variant={loading ? "outlined" : "contained"}
                                        onClick={() => handleSubmintOTP()}
                                    >
                                        Verify OTP
                                    </LoadingButton>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </main>
        </div>
    );
}
